import { extend } from 'vee-validate';
import { confirmed } from 'vee-validate/dist/rules';

extend('confirmed', {
    ...confirmed,
    message: (fieldName, target: any) => {
        return `The ${fieldName} does not match the ${target.target} field`;
    }
});
